module.exports = __webpack_public_path__ + "static/img/son2.c295e895.png";